import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { TokensSchema, WorkspacesResponseSchema } from '../shared/schemas.js';

export const switchWorkspaces = defaultApi.declareEndpoint({
  url: 'authentication/v1/workspaces/',
  method: 'POST',
  requestSchema: z.object({
    company: z.number(),
  }),
  responseSchema: TokensSchema,
});

export const workspaces = defaultClient.query({
  url: 'authentication/v1/workspaces/?is_activated=true&is_active=true' as const,
  method: 'GET',
  querySchema: z.object({
    workspace_id: z.number().optional(),
  }),
  responseSchema: WorkspacesResponseSchema,
  processResponse(data) {
    return data;
  },
});
